<template>
    <div class="c-cookie-banner">
        <transition
            appear
            name="fadein"
        >
            <div
                v-if="visible"
                class="c-cookie-banner__overlay"
            >
            </div>
        </transition>
        <div
            v-slide="visible"
            class="c-cookie-banner__wrapper"
        >
            <div class="c-cookie-banner__text">
                {{ trans('common.cookies.main') }}
                <span class="c-cookie-banner__link">
                    <a
                        :href="`${baseUrl}/cookie-policy`"
                        class="c-cookie-banner__link"
                        target="_blank"
                    >
                        {{ trans('common.cookies.cookie') }}.
                    </a>
                </span>
            </div>
            <div class="c-cookie-banner__btns">
                <base-button
                    :text="trans('common.cookies.manage')"
                    color="white"
                    size="sm"
                    isOutlined
                    @click="openPanel"
                ></base-button>
                <base-button
                    :text="trans('common.cookies.accept')"
                    color="primary"
                    size="sm"
                    @click="acceptCookies"
                ></base-button>
            </div>
        </div>
        <cookie-panel
            v-if="panelVisible"
            v-slide="panelVisible"
            @closePanel="closePanel"
            @acceptCookies="acceptCookies"
        >
        </cookie-panel>
    </div>

</template>

<script>

import CookiePanel from './cookie-panel.vue';
import interactsWithCookieSettings from '../../vue-mixins/interactsWithCookieSettings.js';

export default {
    name: 'CookieBanner',
    components: {
        CookiePanel,
    },
    mixins: [
        interactsWithCookieSettings,
    ],
    data() {
        return {
            visible: !EzekiaLocalStorage.get('cookie-preferences'),
            baseUrl: nal.ezekiaIOUrl,
        };
    },
};

</script>

<style lang="scss" scoped>

.c-cookie-banner {
    &__overlay {
        background: black;
        height: 100%;
        opacity: 0.5;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 98;
    }

    .fadein-enter-active {
        transition: opacity 0.85s;
    }

    .fadein-enter {
        opacity: 0;
    }

    &__wrapper {
        align-items: center;
        background-color: rgb(235 235 235 / 95%);
        bottom: 0;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 400;
        justify-content: center;
        left: 0;
        padding: 10px 12px;
        position: fixed;
        width: 100%;
        z-index: 98;
    }

    &__text {
        margin-bottom: 20px;
    }

    &__link {
        border-bottom: 1px solid #000;
        cursor: pointer;

        &:hover {
            color: #000;
        }
    }

    &__btns {
        display: flex;
        gap: 10px;
        text-align: center;
    }

    @media (width >= 380px) {
        &__wrapper {
            padding: 12px 20px;
        }
    }

    @media (width >= 600px) {
        &__wrapper {
            flex-direction: row;
            padding: 20px 25px;
        }

        &__text {
            margin: 0 20px 0 0;
        }

        &__btns {
            flex-direction: column-reverse;
        }
    }

    @media (width >= 725px) {
        &__wrapper {
            font-size: 16px;
            padding: 25px 30px;
        }
    }

    @media (width >= 860px) {
        &__btns {
            flex-direction: row;
        }
    }
}

</style>
